<template><div><h2 id="underline" tabindex="-1" class="d-docsite--header-2">Underline <a class="header-anchor d-link d-docsite--link d-link" href="#underline" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-td-underline</code> to underline text.</p>
<code-example source-code='&lt;p class=&quot;d-td-underline&quot;&gt;The quick brown fox jumps over the lazy dog.&lt;/p&gt;'>
<p class="d-td-underline">The quick brown fox jumps over the lazy dog.</p>
</code-example>
<h2 id="dotted" tabindex="-1" class="d-docsite--header-2">Dotted <a class="header-anchor d-link d-docsite--link d-link" href="#dotted" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-td-dotted</code> to apply a dotted underline style to the text.</p>
<code-example source-code='&lt;p class=&quot;d-td-dotted&quot;&gt;The quick brown fox jumps over the lazy dog.&lt;/p&gt;'>
<p class="d-td-dotted">The quick brown fox jumps over the lazy dog.</p>
</code-example>
<h2 id="line-through" tabindex="-1" class="d-docsite--header-2">Line Through <a class="header-anchor d-link d-docsite--link d-link" href="#line-through" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-td-line-through</code> to apply a line through the text.</p>
<code-example source-code='&lt;p class=&quot;d-td-line-through&quot;&gt;The quick brown fox jumps over the lazy dog.&lt;/p&gt;'>
<p class="d-td-line-through">The quick brown fox jumps over the lazy dog.</p>
</code-example>
<h2 id="no-decorations" tabindex="-1" class="d-docsite--header-2">No Decorations <a class="header-anchor d-link d-docsite--link d-link" href="#no-decorations" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-td-none</code> to remove text decorations.</p>
<code-example source-code='&lt;p class=&quot;d-td-none&quot;&gt;The quick brown fox jumps over the lazy dog.&lt;/p&gt;'>
<p class="d-td-none">The quick brown fox jumps over the lazy dog.</p>
</code-example>
<h2 id="hover" tabindex="-1" class="d-docsite--header-2">Hover <a class="header-anchor d-link d-docsite--link d-link" href="#hover" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>h:d-td-{n}</code> to change an element's :hover state text decoration.</p>
<code-example source-code='&lt;dt-button kind=&quot;unstyled&quot; class=&quot;h:d-td-underline&quot;&gt;
  The quick brown fox jumps over the lazy dog.
&lt;/dt-button&gt;'>
<dt-button kind="unstyled" class="h:d-td-underline">
  The quick brown fox jumps over the lazy dog.
</dt-button>
</code-example>
<h2 id="focus" tabindex="-1" class="d-docsite--header-2">Focus <a class="header-anchor d-link d-docsite--link d-link" href="#focus" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>f:d-td-{n}</code> to change an element's :focus and :focus-within state text decoration.</p>
<code-example source-code='&lt;dt-button kind=&quot;unstyled&quot; class=&quot;f:d-td-underline&quot;&gt;
  The quick brown fox jumps over the lazy dog.
&lt;/dt-button&gt;'>
<dt-button kind="unstyled" class="f:d-td-underline">
  The quick brown fox jumps over the lazy dog.
</dt-button>
</code-example>
<h2 id="focus-visible" tabindex="-1" class="d-docsite--header-2">Focus Visible <a class="header-anchor d-link d-docsite--link d-link" href="#focus-visible" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>fv:d-td-{n}</code> to change an element's :focus-visible state text decoration [only when focused by keyboard].</p>
<code-example source-code='&lt;dt-button kind=&quot;unstyled&quot; class=&quot;fv:d-td-underline&quot;&gt;
  The quick brown fox jumps over the lazy dog.
&lt;/dt-button&gt;'>
<dt-button kind="unstyled" class="fv:d-td-underline">
  The quick brown fox jumps over the lazy dog.
</dt-button>
</code-example>
<h2 id="classes" tabindex="-1" class="d-docsite--header-2">Classes <a class="header-anchor d-link d-docsite--link d-link" href="#classes" aria-hidden="true">#</a></h2>
<utility-class-table>
  <template #content>
    <tbody>
      <tr v-for=" i in decoration">
        <th scope="row" class="d-code--sm d-docsite-code">.d-td-{{ i }}</th>
        <td class="d-code--sm">
          <span v-if="i === 'dotted'">text-decoration: underline {{ i }} !important</span>
          <span v-else>text-decoration: {{ i }} !important</span>
        </td>
      </tr>
    </tbody>
  </template>
</utility-class-table>
</div></template>


<script setup>
  import { decoration } from '@data/type.json';
</script>